import template from './sw-cms-el-config-acris-blog-author-date.html.twig';

const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-config-acris-blog-author-date', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    emits: ['element-update'],

    computed: {
        layoutOptions() {
            return [{
                label: this.$tc('acris-blog.elements.blogAuthorDate.config.label.layoutOptionDefault'),
                value: 'default'
            }, {
                label: this.$tc('acris-blog.elements.blogAuthorDate.config.label.layoutOptionAuthorText'),
                value: 'author_text'
            }, {
                label: this.$tc('acris-blog.elements.blogAuthorDate.config.label.layoutOptionOnlyAuthor'),
                value: 'only_author'
            }, {
                label: this.$tc('acris-blog.elements.blogAuthorDate.config.label.layoutOptionDateText'),
                value: 'date_text'
            }, {
                label: this.$tc('acris-blog.elements.blogAuthorDate.config.label.layoutOptionOnlyDate'),
                value: 'only_date'
            }];
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-author-date');
        }
    }
});